import React, { memo, useMemo } from 'react';
import EditorViewOnly from '@src/basic-components/EditorViewOnly/EditorViewOnly';
import Poll from '@src/components/Poll/Poll/Poll';
import Text from '@creator/ui/components/Text/Text';
import { isDraftPost, isPendingPost, isPostDeleted, isScheduledPost, parsePostContent } from '@src/model/upvote/helpers';
import { canViewPostDetails, canViewPendingContent } from '@src/model/upvote/permission';
import { useTranslation } from 'react-i18next';
import { usePost } from '@src/store/posts/hooks/usePost';

interface PostContentProps {
    postId: string;
    tokenName: string;
}

const PostContent: React.FC<PostContentProps> = props => {
    const { postId, tokenName } = props;

    const post = usePost(postId);
    const postContent = useMemo(() => post && parsePostContent(post), [post]);
    const { t } = useTranslation();

    // Hide post if viewer isnt a moderator or the post owner
    if (isPostDeleted(postId) && !canViewPostDetails(tokenName, postId) ||
        isPendingPost(postId) && !canViewPendingContent(tokenName) ||
        isDraftPost(postId) && !canViewPendingContent(tokenName) ||
        isScheduledPost(postId) && !canViewPendingContent(tokenName))
        return <Text className="block mt-4 text-sm">{t(`postStatus${post?.status}`)}</Text>;

    function renderEditorViewOnly() {
        if (!postContent) return null;
        return <EditorViewOnly tokenName={tokenName} postId={postId} data={postContent} />;
    }

    function renderPoll() {
        if (!post || !post.pollOptions) return null;

        return <Poll tokenName={tokenName} postId={postId} className="pt-4 mb-4" />;
    }

    return (
        <div className="mt-4 editor-view-only">
            {renderPoll()}
            {renderEditorViewOnly()}
        </div>
    );
};

export default memo(PostContent);
